export enum KeyboardKeyEnum {
    ArrowUp = 'ArrowUp',
    ArrowDown = 'ArrowDown',
}
